/** @format */

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import type { SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ArrowDownIcon } from "@phosphor-icons/react/dist/ssr/ArrowDown";
import { ArrowUpIcon } from "@phosphor-icons/react/dist/ssr/ArrowUp";
import { CurrencyDollarIcon } from "@phosphor-icons/react/dist/ssr/CurrencyDollar";

export interface BudgetProps {
	diff?: number;
	trend: "up" | "down";
	sx?: SxProps;
	value: string;
}

export function CirclesCurrentMonthContribution({
	diff,
	trend,
	sx,
	value,
}: BudgetProps): React.JSX.Element {
	const TrendIcon = trend === "up" ? ArrowUpIcon : ArrowDownIcon;
	const trendColor = trend === "up" ? "#00A76F" : "#FF5630";

	return (
		<Card sx={sx}>
			<CardContent>
				<Stack spacing={3}>
					<Stack
						direction="row"
						sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
						spacing={3}>
						<Stack spacing={1}>
							<Typography color="text.secondary" variant="overline">
								Monthly Contributions
							</Typography>
							<Typography variant="h4">{value}</Typography>
						</Stack>
						<Avatar
							sx={{
								backgroundColor: "primary.main",
								height: "56px",
								width: "56px",
							}}>
							<CurrencyDollarIcon size={24} color="#ffffff" />
						</Avatar>
					</Stack>
					
				</Stack>
			</CardContent>
		</Card>
	);
}
